import axios from "axios";
import { CONSENT_VERSION, DISCLAIMERS } from "@/lib/compliance";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Single source of truth for posting a lead to /api/inquiries.
 *
 * Used by both InquiryForm (full multi-field form) and ContactDialog
 * (compact pop-over). Both POST the same shape — extracting it here cuts
 * the cyclomatic complexity of each caller AND guarantees the EmailOctopus
 * / Proton SMTP pipeline gets a consistent payload no matter which form
 * the visitor used.
 *
 * @param {Object} args
 * @param {string} args.full_name
 * @param {string} args.email
 * @param {string} args.phone
 * @param {string} args.address     - optional; "(unspecified)" if blank
 * @param {string} args.help_with   - combined help_topic + free-text note
 * @param {boolean} args.e_consent  - electronic-comms consent checkbox value
 * @param {string} args.source_url  - window.location.href when available
 */
export async function submitInquiry(args) {
    const {
        full_name,
        email,
        phone,
        address = "",
        help_with,
        e_consent,
        source_url = "",
    } = args;

    await axios.post(`${API}/inquiries`, {
        full_name: full_name.trim(),
        address: (address || "").trim() || "(unspecified)",
        phone: phone.trim(),
        email: email.trim(),
        help_with,
        consent_version: CONSENT_VERSION,
        consent_text: [
            DISCLAIMERS.contactConsent,
            DISCLAIMERS.electronicConsent,
        ].join("\n\n"),
        contact_consent: true,
        electronic_consent: e_consent,
        source_url,
    });
}

/**
 * Email-shape RFC-lite regex shared by every lead form so the rules don't
 * drift between InquiryForm and ContactDialog.
 */
export function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || "").trim());
}
